const onRevoke = (): void => {
  if (typeof window !== 'undefined' && window.hj) {
    window.location.reload();
  }
};

export default onRevoke;
